import * as React from 'react';

import { StyledMenu, StyledMenuItem, StyledMenuButton } from './styles';
import Utils from '../../utils';
import { MenuPosition } from '../../typings/menu';

interface MenuProps {
	config: MenuConfig;
	isDisplayed: boolean;
	position?: MenuPosition;
}

interface MenuConfig {
	[k: string]: {
		label: string;
		icon?: string;
		component?: React.ReactNode;
		hasSeparator?: boolean;
		onClick?: () => void;
		isActive?: boolean;
	} | null;
}

const Menu = ({ config, isDisplayed, position }: MenuProps) => (
	<StyledMenu
		className="DropdownMenu"
		hide={!isDisplayed}
		position={position}
	>
		{Object.values(config).map((item, i) => {
			if (!item) {
				return null;
			}
			const { label, icon, component, hasSeparator, isActive, onClick } = item;
			return (
				<StyledMenuItem
					key={`${label}-${i}`}
					hasSeparator={hasSeparator}
				>
					{component || (
						<StyledMenuButton
							type="button"
							isActive={isActive}
							onClick={onClick}
						>
							{icon && Utils.getSvgIcon(icon)}
							{label}
						</StyledMenuButton>
					)}
				</StyledMenuItem>
			);
		})}
	</StyledMenu>
);


export default Menu;

export { MenuConfig };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DropdownMenu/index.tsx